export default __webpack_public_path__ + "static/media/pencil.a0cf0456.svg";